import api from "../../../components/axiosComp";

// GET bundle by venueId -> { bannerUrl, gallery:[{key,url}], expiresIn, slug }
export async function getVenueMedia(venueId) {
  const { data } = await api.get(`/api/superAdmin/venues/${venueId}/media`);
  return data || { bannerUrl: "", gallery: [], expiresIn: 0, slug: "" };
}

// PRESIGN by venueId: type='banner' | 'carousel'
export async function presignMediaByVenueId(
  venueId,
  type,
  contentType = "image/jpeg",
) {
  const { data } = await api.post(
    `/api/superAdmin/venues/${venueId}/media/presign`,
    {
      type,
      contentType,
    },
  );
  return data; // { key, url, fields, expiresIn }
}

// CONFIRM by venueId
export async function confirmMediaByVenueId(venueId, type, key) {
  const { data } = await api.post(
    `/api/superAdmin/venues/${venueId}/media/confirm`,
    { type, key },
  );
  return data;
}

// (Optional) Deletes still use slug-based endpoints you already have:
export async function deleteBannerBySlug(slug) {
  const { data } = await api.delete(
    `/api/superAdmin/images/${slug}/main-banner`,
  );
  return data;
}
export async function deleteImageByKey(slug, key) {
  const { data } = await api.delete(`/api/superAdmin/images/${slug}/delete`, {
    data: { key },
  });
  return data;
}
